<template>
  <div class="view-tasklists account-lookup-view-list">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin == true" />
      <CSRSidebarMenu v-if="csr == true" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <button
            class="btn btn-red btn-md input-height-15"
            @click="printWindow()">Print</button>
          <div style="padding-left: 0px;width: 100%;font-size: 14px;" id="notes-display">
            <div style="padding-left: 0px;float: left;width: 50%;font-size: 14px;">
              <div style="width: 100%; margin: 10px 0px 5px 0px;border: 1px solid #ddd;padding: 0px 0px 0px 0px;border-radius: 4px;">
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">Account Name: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.accountName }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">Website: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.website }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">Phone: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.phoneNumber }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">Status: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.status }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">NAICS Code: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.naicsCode }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">NAICS ID: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.naicsTitle }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">NAICS Desc: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.naicsDescription }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
              </div>
            </div>

            <div style="padding-left: 0px;float: left;width: 50%;font-size: 14px;">
              <div style="margin: 10px 0px 5px 15px;border: 1px solid #ddd;padding: 0px 0px 0px 0px;border-radius: 4px;">
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">Address: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.address }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">City: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.city }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">State: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.stateName }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">Postal Code: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.zip }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">Country: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.countryName }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
                <div style="padding: 5px; width: 100%; ">
                  <div style="font-weight: bold;width: 30%;padding: 0px 15px;float: left;">Market Area: </div>
                  <div style="width: 55%;float: left;">{{ accountDetails.marketArea }}</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>
              </div>
            </div>
            <div style="clear:both;padding: 5px 0px 0px 0px;"></div>

            <div style="padding-left: 0px;float: left;width: 100%;font-size: 14px;">
              <div style="margin: 10px 0px 5px 0px;border: 1px solid #ddd;padding: 0px 0px 0px 0px;border-radius: 4px;">
                <div style="padding: 5px;">
                  <div style="width: 100%;padding: 0px 15px;">
                    <div style="width: 100%;" v-for="(note, index) in display_notes">
                      <div style="padding: 5px 0px 0px 0px;">
                        <span style="font-weight: bold;">Note By: </span>
                        <span>({{ note.created_by }}) on {{ FollowDate(note.createdAt) }}</span>
                      </div>
                      <div style="padding: 5px 0px 0px 0px;">
                        <span style="font-weight: bold;">Follow-up: </span>
                        <span v-if="note.followUpReason">Yes</span>
                        <span v-else>No</span>
                      </div>
                      <div v-if="note.followUpReason" style="padding: 5px 0px 0px 0px;">
                        <span style="font-weight: bold;">Follow-up Reason: </span>
                        <span>{{ note.followUpReason }} on {{ FollowDate(note.followUpDate) }} By ({{ note.created_by }})</span>
                      </div>
                      <div v-if="note.followUpReason" style="padding: 5px 0px 0px 0px;">
                        <span style="font-weight: bold;">Follow-up Completed: </span>
                        <span v-if="note.status === 'COMPLETED'">Yes</span>
                        <span v-else>No</span>
                      </div>
                      <div style="padding: 5px 0px 0px 0px;">
                        <span style="font-weight: bold;">Notes: </span>
                        <span>{{ note.notes }}</span>
                      </div>
                      <hr style="width: 100%;margin-left: -15px;">
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import moment from 'moment';
import CSRSidebarMenu from '../shared/csr_sidebar_menu.vue';

export default {
        data() {
          return {
            accountId: '',
            display_notes: [],
            accountDetails: {},
            researcher: false,
            masterAdmin: false,
            csr: false,
          }
        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
          CSRSidebarMenu,
        },
        methods: {
          printWindow: function () {
            var printContents = document.getElementById('notes-display').innerHTML;
            var NewWin = window.open("", "PlatformReport");
            NewWin.document.write(printContents);
            NewWin.document.close();
            NewWin.print();
            NewWin.close();
          },
          FollowDate(value) {
            return moment(String(value)).utc().format('ddd. MMM. D, YYYY h:mm A')
          },
          loadNotesAction: function() {
            axios("/notes", {
              method: 'GET',
              params: {
                account_id: this.accountId,
              }
            })
            .then(response => {
              this.display_notes = response.data;
            })
            .catch(error => {

            });

          },
          getAccountLookupDetailData: function() {
            axios("/enterprise_lookup_detail", {
              method: 'GET',
              params: {
                account_id: this.accountId,
              }
            })
            .then(response => {
              this.accountDetails = response.data.data[0];
            })
            .catch(error => {

            });
          },

        },
        mounted() {

        },
        created() {
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }
          this.accountId = this.$route.params.account_id;
          this.getAccountLookupDetailData();
          this.loadNotesAction();
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_notes_printout.vue